<template>
    <div id="wp-page-contact-list">
        <AppBreadCrumb :paths="[{ title: $t('wp.whatsapp') }]" :select="true">
            <a-button
                v-if="initialized && status.purchased"
                class="actionButtonBreadcrumb"
                type="danger"
                @click="unsubscribe"
            >
                {{ $t("wp.unsubscribe") }}
            </a-button>
        </AppBreadCrumb>
        <div class="d-flex" style="background-color: #ffffff">
            <div class="side-menubar-wrapper" style="width: 15%">
                <WhatsappMenu selected-page="contact-list" />
            </div>
            <div class="main-content" style="width: 85%">
                <ActivateWhatsappAlert v-if="!whatsappPlanExists" />
                <div v-else>
                    <h3 class="title">{{ $t("wp.contactList") }}</h3>
                    <div v-if="selections.length" class="selection-bar">
                        <section class="uncheck" @click="unselectAll">
                            <span class="material-icons"> arrow_back </span>
                            {{ $t("chatbotv2.uncheckAll") }}
                        </section>
                        <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
                        <section class="queries">+{{ selections.length }}{{ $t("wp.contactSelected") }}</section>
                        <section class="actions">
                            <a-popover
                                :overlayClassName="'no-padding'"
                                :visible="createCustomerGroupFormVisible"
                                placement="bottom"
                                trigger="click"
                                @visibleChange="changeCreateGroupPopupVisible"
                            >
                                <div slot="content">
                                    <CreateCustomerGroupWithNumbers
                                        :contacts="selections"
                                        :on-cancelled="() => changeCreateGroupPopupVisible(false)"
                                        :on-completed="() => changeCreateGroupPopupVisible(false, true)"
                                    />
                                </div>

                                <a-button
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('wp.createCustomerGroup')"
                                    ghost
                                    >{{ $t("wp.createCustomerGroup") }}
                                </a-button>
                            </a-popover>

                            <a-button class="d-none" ghost>{{ $t("wp.sendBroadcastMessage") }}</a-button>
                        </section>
                    </div>
                    <div class="my-1 wp-list-searching-input">
                        <span class="wp-list-search-bar">
                            <b-button @click="refresh" class="m-2" :disabled="refreshAllow">{{
                                $t("message.refresh")
                            }}</b-button>
                            <span style="display: flex">
                                <a-input-search
                                    v-model="searchText"
                                    :placeholder="$t('message.search')"
                                    class="row search-input"
                                    @input="onSearch($event.target.value)"
                                />
                            </span>
                        </span>
                        <div class="mr-5">
                            <a-button @click="showModal">
                                {{ $t("wp.startChatWithAnyNo") }}
                            </a-button>
                            <a-modal
                                :confirm-loading="confirmLoading"
                                :title="$t('wp.typeInANumberDesc')"
                                :visible="visible"
                                class="row d-flex flex-row"
                                @cancel="handleCancel"
                                @ok="handleOk(wpContactNumber)"
                            >
                                <div v-if="showAlertMessage" class="pb-3">
                                    <a-alert :message="$t('wp.toLittleChar')" type="error" banner />
                                </div>
                                <div class="d-flex flex-row align-items-center justify-content-center">
                                    <vue-country-code
                                        :defaultCountry="userLastCountry"
                                        :enabledCountryCode="true"
                                        class="col-3 country-code"
                                        @onSelect="onSelect($event)"
                                    />
                                    <div class="col-8">
                                        <a-input
                                            v-model="wpContactNumber"
                                            v-mask="'##########'"
                                            :placeholder="$t('message.phone')"
                                            autocomplete="off"
                                            trim
                                            type="text"
                                        />
                                    </div>
                                </div>
                            </a-modal>
                        </div>
                    </div>
                    <div>
                        <a-table
                            :key="'vtable-' + renderCount"
                            :columns="cols"
                            :dataSource="contactListData"
                            :loading="loading"
                            :locale="{
                                emptyText: $t('message.noContactFound'),
                            }"
                            :pagination="pagination"
                            :row-selection="{ onChange: rowSelectionOnChange, selectedRowKeys: selections }"
                            class="custom-table"
                            rowKey="id"
                            size="small"
                            @change="handleTableChange"
                        >
                            <div></div>
                            <div slot="avatarSlot" slot-scope="data, item" class="p-1">
                                <a-avatar
                                    :size="30"
                                    :src="$_.get(item, 'profilePicThumbObj.eurl')"
                                    :username="item.name"
                                    shape="square"
                                    style="background-color: #3899ff; border-radius: 7px !important"
                                >
                                    {{ !!item.name ? item.name.substr(0, 1).toLocaleUpperCase() : "" }}
                                </a-avatar>
                            </div>
                            <div slot="phoneNumber" slot-scope="data, item" class="p-1">
                                {{ item.phoneNumber.slice(0, -5) }}
                            </div>
                            <div slot="action" slot-scope="data, item">
                                <div class="d-flex justify-content-end" style="margin-right: 30px !important">
                                    <md-button
                                        id="joinChat"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('wp.startChatWp')"
                                        data-v-step="16"
                                        @click="startChat(item.phoneNumber)"
                                    >
                                        {{ $t("wp.startChatWp") }}
                                        <md-icon style="color: #06e576; font-size: 12px"> whatsapp</md-icon>
                                    </md-button>
                                    <button
                                        class="delete-chat"
                                        id="deleteChat"
                                        content="Kişiyi Sil"
                                        data-v-step="16"
                                        @click="deleteVisitorConfirm(item)"
                                    >
                                        <span class="material-icons">close</span>
                                    </button>
                                </div>
                            </div>
                        </a-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";
import { tableSorter } from "../../../../../utils/utils";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import Fuse from "fuse.js";
import WhatsappMenu from "../../components/WhatsappMenu";
import "../../whatsapp.scss";
import CreateCustomerGroupWithNumbers from "./CreateCustomerGroupWithNumbers";
import { updateIntegration } from "../../../../../api/billing";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb";
import _ from "lodash";
import ActivateWhatsappAlert from "../../components/ActivateWhatsappAlert";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import VueTheMask from "vue-the-mask";
import Multiselect from "vue-multiselect";
import ChatWatcher from "../../../../../ChatWatcher";

Vue.use(VueTheMask);
Vue.use(VueCountryCode);

const log = log2("ContactListV2");

export default {
    name: "ContactListV2",
    components: {
        WhatsappMenu,
        CreateCustomerGroupWithNumbers,
        AppBreadCrumb,
        ActivateWhatsappAlert,
        VueCountryCode,
        Multiselect,
    },
    props: {
        text: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            showAlertMessage: false,
            internationalCallingCode: "90",
            wpContactNumber: "",
            createCustomerGroupFormVisible: false,
            lastPersonelContacts: [],
            searchText: "",
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                total: 0,
                current: 1,
                defaultPageSize: 10,
                hideOnSinglePage: true,
                pageSizeOptions: ["10", "15", "20", "50", "100"],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            cols: [
                {
                    key: "profilePicThumbObj",
                    dataIndex: "profilePicThumbObj.eurl",
                    title: this.$t("message.profile"),
                    ...tableSorter("profilePicThumbObj", "string", this.currentSort),
                    scopedSlots: { customRender: "avatarSlot" },
                },
                {
                    key: "name",
                    dataIndex: "name",
                    title: this.$t("message.name"),
                    ...tableSorter("name", "string", this.currentSort),
                    scopedSlots: { customRender: "name" },
                },
                {
                    key: "phoneNumber",
                    dataIndex: `phoneNumber`,
                    title: this.$t("message.number"),
                    ...tableSorter("phoneNumber", "string", this.currentSort),
                    scopedSlots: { customRender: "phoneNumber" },
                },
                {
                    key: "channelName",
                    dataIndex: `channelName`,
                    title: "Kanal adı",
                    ...tableSorter("channelName", "string", this.currentSort),
                    scopedSlots: { customRender: "channelName" },
                },
                {
                    title: "Action",
                    key: "operation",
                    scopedSlots: { customRender: "action" },
                    width: "100px",
                },
            ],
            loading: true,
            refreshAllow: false,
            selections: [],
            contactListData: [],
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-qr"),
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            contacts: (state) => state.whatsapp.contacts,
            totalContacts: (state) => state.whatsapp.total,
            status: (state) => state.whatsapp.info.status,
            searchingResultsOfWpContact: (state) => state.whatsapp.searchingResultsOfWpContact,
            initialized: (state) => state.whatsapp.info.initialized,
            whatsappPlanExists: (state) =>
                _.get(state.setting.settings, "whatsapp.plus.enabled", false) ||
                _.get(state.setting.settings, "whatsapp.enabled", false),
            whatsappPlusActive: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
            wpInfo: (state) => state.whatsapp.info.initialized,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            isHealthy: "whatsapp/isHealthy",
            myActiveConversations: "chat/getMyActiveConversations",
            whatsappServiceIsHealthy: "whatsapp/isHealthy",
        }),
        contactList() {
            let validContacts = this.contacts.filter((x) => x.phoneNumber.includes("@c") && !!x.name);
            const validContactsMap = validContacts.reduce((acc, cur) => {
                acc[cur.phoneNumber] = cur;
                return acc;
            }, {});
            return {
                array: validContacts,
                map: validContactsMap,
            };
        },
    },
    async mounted() {
        await this.sendGetContactMessage();
        this.loading = false;
    },
    watch: {
        totalContacts(nV, oV) {
            this.pagination.total = this.totalContacts;
        },
        contacts(nV, oV) {
            this.contactListData = nV;
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            getContactListNullChannel: "chat/getContactListNullChannel",
            deleteVisitor: "visitor/deleteVisitor",
        }),
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
            setSearchingResultWPContact: "whatsapp/setSearchingResultWPContact",
            setContacts: "whatsapp/setContacts",
            deleteContact: "whatsapp/deleteContact",
        }),
        async unsubscribe() {
            const self = this;
            this.$confirm({
                title: this.$t("wp.cancelWpInetgration"),
                content: this.$t("wp.terminatelWpInetgration"),
                okText: this.$t("wp.unsubscribeWpInetgration"),
                okType: "danger",
                cancelText: this.$t("wp.wpBack"),
                width: 600,
                height: 600,
                async onOk() {
                    await updateIntegration(self.siteId, "whatsapp", false);
                    self.getSettings();
                    sendSocketMessage("user settings-updated", {
                        siteId: self.siteId,
                    });
                    self.showWizard = false;
                    localStorage.removeItem("wp-agreement-accepted");
                    self.changePurchaseStatus(false);
                    sendSocketMessage("whatsapp unsubscribe", {
                        siteId: self.siteId,
                    });
                },
                onCancel() {},
            });
        },
        changeCreateGroupPopupVisible(visible, unselectMode = false) {
            this.createCustomerGroupFormVisible = visible;
            if (unselectMode) {
                this.selections = [];
            }
        },
        selectAll() {
            this.selections = this.contacts.map((x) => x.phoneNumber);
            this.renderCount++;
        },
        unselectAll() {
            this.selections = [];
            this.renderCount++;
        },
        getSelectedContacts() {
            const { map, array } = this.contactList;
            const selectedContacts = this.selections
                .map((x) => map[x])
                .map((x) => ({
                    number: x.phoneNumber,
                    attributes: {
                        name: x.name,
                    },
                }));
            log("getSelectedContacts", { selectedContacts, selections: this.selections });
            return selectedContacts;
        },
        rowSelectionOnChange(selectedRowKeys, selectedRows) {
            this.selections = selectedRowKeys;
            log("rowSelectionOnChange", { selections: this.selections });
            this.renderCount++;
        },
        startChat(whatsappNumber) {
            if (!this.whatsappServiceIsHealthy) {
                this.$message.error("Whatsapp servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyiniz.");
                this.visible = false;
                return;
            }
            whatsappNumber = whatsappNumber?.includes("@c.us") ? whatsappNumber : whatsappNumber + "@c.us";
            ChatWatcher.startChatImmediately({
                whatsappNumber: whatsappNumber,
            });
        },
        async sendGetContactMessage() {
            const allContacts = await this.getContactListNullChannel({
                pageCount: this.pagination.current,
                perPage: this.pagination.pageSize || this.pagination.defaultPageSize || 10,
            });
            const whatsappContacts = allContacts.result.map((x) => {
                x.name = !!x.fullname ? x.fullname : !!x.name ? x.name : "-";
                x.phoneNumber = !!x.whatsappNumber ? x.whatsappNumber : "-";
                x.channelName = !!x.channel ? x.channel.name : "-";
                x.name = !!x.name && x.name !== "-" ? x.name : x.conversation.fullname ? x.conversation.fullname : "-";
                x.phoneNumber =
                    !!x.phoneNumber && x.phoneNumber !== "-"
                        ? x.phoneNumber
                        : !!x.conversation.whatsappNumber
                        ? x.conversation.whatsappNumber
                        : "-";
                return x;
            });
            this.pagination.total = allContacts.totalResult;
            this.setContacts({ whatsappContacts, whatsappContactsTotal: allContacts.totalResult });
            this.loading = false;
        },
        refresh: _.debounce(function () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.pagination.current = 1;
            this.sendGetContactMessage();
            this.contactListData = this.contacts;
        }, 400),

        async handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            await this.sendGetContactMessage();
            this.contactListData = this.contacts;
        },
        getFilteredRows(getContacts = this.contacts) {
            log("getFilteredRows before", getContacts);
            let fuzzySearch = new Fuse(getContacts, { keys: ["name", "phoneNumber"] });
            const filteredRows =
                this.searchText.length > 0 ? fuzzySearch.search(this.searchText).map((x) => x.item) : getContacts;
            log("filteredRow after", filteredRows);
            return filteredRows;
        },
        onSearch(value) {
            this.searchText = value;
            this.contactListData = this.getFilteredRows();
        },
        onSelect(value) {
            log("onSelect", value);
            this.internationalCallingCode = value.dialCode;
        },
        showModal() {
            this.visible = true;
        },
        deleteVisitorConfirm(item) {
            this.$confirm({
                title: "Kişiyi sil",
                content: "Kişiyi slimek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: async () => {
                    this.refreshAllow = true;
                    this.$message.loading("Konuşma silindi", 0);
                    await this.deleteVisitor(item._id)
                        .then((res) => {
                            this.$message.destroy();
                            this.$message.success("Konuşma silindi");
                            this.deleteContact(item._id);
                            this.contactListData = this.contactListData.filter((x) => x._id !== item._id);
                        })
                        .finally(() => {
                            this.refreshAllow = false;
                        });
                },
            });
        },
        handleOk(number) {
            if (!this.whatsappServiceIsHealthy) {
                this.$message.error("Whatsapp servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyiniz.");
                this.visible = false;
                return;
            }
            this.wpContactNumber = number.replace(/[{()}]/g, "");
            const contactNumber = this.internationalCallingCode + this.wpContactNumber;
            if (contactNumber.length < 6) {
                this.showAlertMessage = true;
                return;
            }
            this.confirmLoading = true;
            this.showAlertMessage = false;
            this.visible = false;
            this.confirmLoading = false;

            const searchedContacts = JSON.parse(JSON.stringify(this.searchingResultsOfWpContact));
            const isNumberExistInSearchHistory = searchedContacts[number];
            if (isNumberExistInSearchHistory !== undefined) {
                this.readyToChatStartingControl(isNumberExistInSearchHistory);
            } else {
                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "whatsapp_contacts_is_includes_number"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        let searchingResultWPContact = {};
                        const isExist = _.get(x, "data.contactIsExist") || false;
                        searchingResultWPContact[`${number}`] = isExist;
                        this.readyToChatStartingControl(isExist);
                        this.setSearchingResultWPContact(searchingResultWPContact);
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    });

                sendSocketMessage("whatsapp number-is-exist-in-contacts", {
                    siteId: this.site._id,
                    searchingPhoneNumber: contactNumber,
                });
            }
        },
        readyToChatStartingControl(isExist) {
            if (isExist) {
                this.startChat(this.internationalCallingCode + this.wpContactNumber);
            } else if (this.whatsappPlusActive) {
                this.startChat(this.internationalCallingCode + this.wpContactNumber);
            } else {
                this.controlWhatsappPlusIntegration();
            }
        },
        handleCancel(e) {
            this.visible = false;
            this.showAlertMessage = false;
        },
        openNotificationWithIcon(featureType, type = "warning") {
            const messages = {
                wpPlusAndLicenceRequired: {
                    message: this.$t("wp.wpPlusAndLicenceRequired"),
                    description: `${this.$t("wp.wpPlusAndLicenceRequiredDesc")} `,
                },
            };
            const message = messages[featureType];
            const key = `plan`;
            this.$notification[type]({
                message: message.message,
                description: message.description,
                placement: "topRight",
                key,
                btn: (h) => {
                    let buttonText = !this.whatsappPlusActive
                        ? this.$t("message.changePlan")
                        : this.$t("message.close");
                    return h(
                        "a-button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    if (featureType === "wpPlusAndLicenceRequired") this.$router.push("/settings/billing");
                                    this.$notification.close(key);
                                },
                            },
                        },
                        buttonText
                    );
                },
            });
        },
        controlWhatsappPlusIntegration() {
            if (!this.whatsappPlusActive) {
                this.openNotificationWithIcon("wpPlusAndLicenceRequired");
            }
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#wp-page-contact-list {
    .delete-chat {
        background: none;
        border: none;
        margin-right: 5px;

        &:hover {
            background-color: #c0bfbf;
            border-radius: 10px;
        }
    }

    .ant-modal-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        display: flex !important;
        flex-direction: row !important;
        height: 80px !important;
    }

    .ant-table-row {
        border-bottom: 1px solid lightgrey;
    }

    .ant-table table {
        border-collapse: collapse !important;
    }

    .ant-table-small {
        border: none !important;
    }

    .ant-table-body > table > .ant-table-tbody > tr > td {
        border: none !important;
    }

    .ant-table-body > table {
        border-right: none !important;
        border-left: none !important;
        line-height: 10px !important;
    }

    .ant-table-body > table > .ant-table-thead > tr > th {
        border: none !important;
    }

    .ant-table-small {
        .ant-table-tbody {
            td {
                padding: 2px 2px !important;
                height: 10px !important;
            }

            .ant-table-row {
                height: 10px !important;
            }
        }
    }

    .selection-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 10px 30px;
        position: static;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;
            gap: 5px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .wp-list-searching-input {
        margin: 5px 5px !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }

    .inputs {
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px #00000080;
        box-shadow: 0 0 1px #00000080;
    }

    .wp-list-search-bar {
        display: flex;
        align-items: center;
        gap: 20px;
    }
}
</style>
